<template>
  <div
    class="pl-6 pr-4 sm:w-4/12 sm:border-r sm:border-gpx_gray-900 md:pl-12 md:pr-6"
  >
    <ReportDetailsNavBar
      v-if="!isPublic"
      class="h-[64px] sm:h-[48px] sm:translate-y-2"
    />
  </div>
  <div class="hidden justify-between px-4 py-2 sm:flex sm:w-8/12 md:pr-12">
    <div class="flex gap-2">
      <UITooltip text="Download Report">
        <Button
          size="sm"
          variant="tertiary"
          icon="ArrowDownTrayIcon"
          :loading="isLoading"
          @click="$emit('downloadReport')"
        >
          Download Report
        </Button>
      </UITooltip>
    </div>
  </div>
</template>

<script setup>
import ReportDetailsNavBar from './ReportDetailsNavBar.vue';

defineProps({
  isPublic: Boolean,
  isLoading: Boolean,
});
defineEmits(['downloadReport']);
</script>
